import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../../base/base-component.component';

@Component({
  selector: 'side-left-bar',
  templateUrl: './side-left-bar.component.html',
  styleUrls: ['./side-left-bar.component.css']
})
export class SideLeftBarComponent extends BaseComponent implements OnInit {

  constructor(
    translateService: TranslateService) {
    super(translateService);
    this.setTranslateContext('SideLeftBarComponent');
  }

  ngOnInit() {
  }

}
